import { useCallback, useEffect, useState } from "react";

const KEY = "ke_drift_theme";

const read = () => {
  try {
    const v = localStorage.getItem(KEY);
    return v === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
};

/* Drift theme: light by default, dark on request, remembered per browser. Scopes Drift tokens via the `drift` class. */
export function useDriftTheme() {
  const [theme, setThemeState] = useState(read);

  useEffect(() => {
    const el = document.documentElement;
    el.classList.add("drift");
    el.classList.toggle("dark", theme === "dark");
    return () => {
      el.classList.remove("drift");
      el.classList.remove("dark");
    };
  }, [theme]);

  const setTheme = useCallback((t) => {
    setThemeState(t);
    try { localStorage.setItem(KEY, t); } catch { /* ignore */ }
  }, []);

  const toggle = useCallback(() => setTheme(theme === "dark" ? "light" : "dark"), [theme, setTheme]);

  return { theme, setTheme, toggle, isDark: theme === "dark" };
}
